<template>
  <div class="page__nav" :class="headerSize">
    <div class="page__nav__wrapper">
      <router-link class="page__nav__logo" to="/" exact>
        <h1>FDS</h1>
        <span>Feelgood Design System</span>
      </router-link>
      <fds-button
        class="menu-button"
        variant="minor-invert"
        :state="nav ? 'active' : null"
        @click="handleMenuClick"
        :icon="nav ? 'hamburgerClose' : 'hamburgerOpen'"
        icon-pos="right"
      >
        <button
          :aria-expanded="`${nav}`"
          data-cy="burger-menu-button"
        >
          Menu
        </button>
      </fds-button>
    </div>
    <nav v-if="showMenuList" class="page__nav__menu">
      <ul>
        <li><router-link to="/" exact @click.native="handleMenuClick">Welcome</router-link></li>
        <li><router-link to="/colors" @click.native="handleMenuClick">Colors</router-link></li>
        <li><a :href="storybookPath">Components</a></li>
        <li><router-link to="/core" @click.native="handleMenuClick">FDS Core</router-link></li>
        <li><router-link to="/icons" @click.native="handleMenuClick">Icons</router-link></li>
        <li><router-link to="/logotypes" @click.native="handleMenuClick">Logotypes</router-link></li>
        <li><router-link to="/spacing" @click.native="handleMenuClick">Spacing</router-link></li>
        <li><router-link to="/typography" @click.native="handleMenuClick">Typography</router-link></li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'PageMenu',
  data () {
    return {
      activeSubnav: null,
      timerId: null,
      size: 's',
      nav: false
    }
  },
  created () {
    window.addEventListener('resize', () => {
      this.debounceHandler()
    })
  },
  mounted () {
    this.checkPath()
    this.handleResize()
  },
  computed: {
    headerSize () {
      if (this.nav) {
        return `page__nav--size-${this.size} page__nav--size-${this.size}--active`
      }
      return `page__nav--size-${this.size}`
    },
    showMenuList () {
      if (this.size === 's' && !this.nav) {
        return false
      } else {
        return true
      }
    },
    storybookPath () {
      const path = window.location
      switch (path.hostname) {
        case 'localhost':
        case 'dev-kund.feelgood.se':
          return 'http://dev-kund.feelgood.se:8402/'
        case 'preprod-design.feelgood.se':
          return 'https://preprod-storybook.digital.feelgood.se/'
        case 'design.feelgood.se':
          return 'https://storybook.feelgood.se/'
        default:
          return '-'
      }
    }
  },
  methods: {
    handleMenuClick () {
      this.nav = !this.nav
    },
    showNav () {
      this.nav = !this.nav
    },
    debounce (fn, delay = 300) {
      return ((...args) => {
        clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
          this.timerId = null
          fn(...args)
        }, delay)
      })()
    },
    debounceHandler () {
      this.debounce(() => {
        this.handleResize()
      }, 250)
    },
    handleResize () {
      this.nav = false
      const width = window.innerWidth
      // $bp-1124
      if (width > 1123) {
        this.size = 'm'
      } else {
        this.size = 's'
      }
    },
    toggleSubnav (sub) {
      this.activeSubnav = sub === this.activeSubnav ? null : sub
    },
    checkPath () {
      const subPathName = location.pathname.split('/')[1]
      if (subPathName === 'core') {
        this.activeSubnav = 'core'
      }
    }
  }
}
</script>

<style lang="scss">
.page__nav__logo {
  display: block;
  text-align: center;
  text-decoration: none;
  &:hover, &:active, &:focus {
    text-decoration: none;
  }
  img {
    width: 110px;
    vertical-align: middle;
  }
  h1 {
    color: set-color('white_t', 'solid');
    margin: 0 0 set-gutter('xs') 0;
  }
  span {
    display: block;
    color: set-color('white_t', 'solid');
    font-size: set-size('l');
    font-weight: 300;
  }
}
.page__nav__menu {
  height: 100%;
  width: 100%;
  overflow: auto;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      margin: 0;
    }
    a {
      transition: background-color .15s ease-in-out;
      color: set-color('white_t', 'solid');
      text-decoration: none;
      display: block;
      padding: set-gutter('m') set-gutter('xl');
      &:hover {
        background-color: set-color('blue', 800);
        color: set-color('blue', 100);
        + .page__nav__menu__expander__button {
          color: set-color('blue', 700);
        }
      }
      &:active {
        background-color: set-color('blue', 900);
      }
      &.router-link-active {
        background-color: set-color('blue', 100);
        color: set-color('blue', 700);
        font-weight: 800;
        + .page__nav__menu__expander__button {
          color: set-color('blue', 700);
        }
      }
    }
  }
  ul ul {
    margin-top: set-gutter('xs');
    a {
      padding: set-gutter('xs') set-gutter('xs') set-gutter('xs') set-gutter('xl');
      font-size: 85%;
    }
  }
  &__expander {
    position: relative;
    &__button {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: set-gutter('s');
      top: 50%;
      transform: translateY(-50%) rotate(135deg);
      transition: all .15s ease-in-out;
      color: set-color('white_t', 'solid');
      background-color: transparent;
      border-radius: set-radius('round');
      padding: set-gutter('xs');
      &:hover {
        background-color: set-color('blue', 100);
        color: set-color('blue', 700);
      }
    }
    &.active {
      .page__nav__menu__expander__button {
        transform: translateY(-50%) rotate(0);
      }
    }
  }
}
</style>
